import { render, staticRenderFns } from "./YGOIDJUX.vue?vue&type=template&id=5343d4b2&scoped=true&"
import script from "./YGOIDJUX.vue?vue&type=script&lang=js&"
export * from "./YGOIDJUX.vue?vue&type=script&lang=js&"
import style0 from "./YGOIDJUX.vue?vue&type=style&index=0&id=5343d4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343d4b2",
  null
  
)

export default component.exports